/* eslint-disable */

import request from '@/utils/request'

export function getPriceCategoryApi(query) {
  return request({
    url: '/config-service/v1/hotel/price-category',
    method: 'get',
    params: query
  })
}

export function addPriceCategoryApi(query) {
  return request({
    url: '/config-service/v1/hotel/price-category',
    method: 'post',
     data: query
  })
}

export function updatePriceCategoryApi(query) {
  return request({
    url: '/config-service/v1/hotel/price-category',
    method: 'put',
    data: query
  })
}
export function deletePriceCategoryApi(query) {
  return request({
    url: '/config-service/v1/hotel/price-category',
    method: 'delete',
    data: query
  })
}
